// One execution, then forty of them.
//
// Asked for 2026-10-23: a 20 000 m drum of MYYM 3x2.5 that has to come off as
// 40 drums of 500 m. "in momentul asta trebuie sa creez 40 de executii, poti sa
// imi pui ceva de genul sa fac o executie si dupa aia sa o multiplic."
//
// So: fill in ONE drum — machine, drum material, Ø, length — and say how many of
// it there are.
//
// ── what a copy must NOT carry ─────────────────────────────────────────────
//
// `taskId` / `tokenId` name a drum that already exists. Copying them makes forty
// executions claiming to be one launched task, and the backend resolves inputs
// and reservations BY those ids.
//
// `mergeSlot` is worse than useless: `planMergeSlots` THROWS `MergeSlotConflict`
// when one product puts two executions on the same slot ("A product cannot be
// merged with itself"). Forty copies of an execution pinned to group 1 would
// refuse the whole launch. Copies are left on automatic, which numbers them
// 0,1,2… — each on its own drum, which is the point of making forty of them.
//
// Everything that describes the DRUM is copied, because that is what is being
// repeated: the machine, the reel, the length, where it goes next, and which
// upstream it draws from.
//
// Pure. Mirrored into tests/.generated by tests/tools/mirror.mjs.

// Fields that identify a drum that already exists, or that must be unique per
// execution. Dropped from every copy.
const NOT_COPIED = [
  'id',
  'taskId',
  'tokenId',
  'mergeSlot',
  'mergeSolo',
  '_locked',
  '_merged',
  '_producedLength',
  '_reconcileOrigin',
  '_reconcileOriginColor',
  'corrections',
  'edits'
];

/** One copy of an execution, as a NEW drum. */
export function cloneExecution(exec, id) {
  const copy = { ...(exec || {}) };
  for (const field of NOT_COPIED) delete copy[field];
  copy.id = id;
  return copy;
}

/**
 * Repeat an execution until there are `total` of it.
 *
 * @param list   the phase's executions
 * @param index  which one to repeat
 * @param total  how many there should be in the end, this one included
 * @param nextId () => a fresh id, called once per copy
 * @returns a NEW array with the copies inserted directly after the original, so
 *          they read in the order they will be made rather than at the bottom
 *          of a list of forty.
 */
export function multiplyExecution({ list = [], index, total, nextId } = {}) {
  const execs = Array.isArray(list) ? list : [];
  const original = execs[index];
  const want = Math.floor(Number(total));

  if (!original || !Number.isFinite(want) || want < 2) return execs;

  const copies = [];
  for (let i = 1; i < want; i += 1) {
    copies.push(cloneExecution(original, nextId ? nextId(i) : `${original.id}-${i}`));
  }

  return [...execs.slice(0, index + 1), ...copies, ...execs.slice(index + 1)];
}

/**
 * What the control should say before it is pressed.
 *
 * `fits` is what the metres allow; `total` is what the planner asked for,
 * clamped to it. The sentence is the whole reason this is not just a number box:
 * 40 × 500 m = 20 000 m is checkable at a glance, and a request for 45 says so
 * instead of silently making 40.
 */
export function multiplyPreview({ remaining = 0, each = 0, want = null } = {}) {
  const per = Number(each) || 0;
  const left = Number(remaining) || 0;
  if (!(per > 0)) return null;

  const fits = Math.floor((left + per * 0.001) / per);
  if (fits < 1) return { fits: 0, total: 0, metres: 0, clamped: false, each: per };

  const asked = want == null ? fits : Math.floor(Number(want)) || 0;
  const total = Math.max(1, Math.min(asked, fits));

  return {
    fits,
    total,
    each: per,
    metres: Math.round(total * per * 10) / 10,
    clamped: asked > fits
  };
}
